// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.title[data-v-744b1ada]{\r\n  padding-left: 0;\r\n  font-size: 20px;\r\n  color: #231F20;\n}\n.hr[data-v-744b1ada]{\r\n  margin-bottom: 20px;\r\n  border-width: 1px;\r\n  color: transparent;\n}\n.theme--light.v-divider[data-v-744b1ada] {\r\n  border-color: #231F20 !important;\n}\n.error-text[data-v-744b1ada]{\r\n  color: red;\n}\n.error-text[data-v-744b1ada]:first-child {\r\n  margin: 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
